// ─── Workshop Truck Availability Tracker ───
// Lightweight API helper (fetch‑based, no Axios overhead for simple calls)
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

/**
 * API base URL:
 *   - Production: https://workshop-tracker-api.gdompey.workers.dev
 *   - Local dev:  '' (empty — Vite proxy handles /api → localhost:8787)
 */
const API_BASE = import.meta.env.VITE_API_URL ?? ''

/**
 * Thin wrapper around the native `fetch` API.
 * - `get`   → GET  request, returns parsed JSON.
 * - `patch` → PATCH request with JSON body, returns parsed JSON.
 */
export const api = {
  /** Perform a GET request and return the parsed JSON response. */
  get: <T = unknown>(path: string): Promise<T> =>
    fetch(`${API_BASE}${path}`).then((r) => {
      if (!r.ok) throw new Error(`GET ${path} failed: ${r.status}`)
      return r.json() as Promise<T>
    }),

  /** Perform a PATCH request with a JSON body and return the parsed JSON response. */
  patch: <T = unknown>(path: string, body: unknown): Promise<T> =>
    fetch(`${API_BASE}${path}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error(`PATCH ${path} failed: ${r.status}`)
      return r.json() as Promise<T>
    }),
}
